import { sentry } from '@frontend/tracking';
import { useGetBusinessDetailsQueries } from '../queries';

const SUPPORTED_BOOKING_SOFTWARE = ['NEXHEALTH', 'WEAVE'];

export const useSupportedBookingSoftware = ({
  locationIds,
  orgId,
  isEnabled = false,
}: {
  locationIds?: string[];
  orgId: string;
  isEnabled?: boolean;
}) => {
  const scopedLocationIds = locationIds?.filter(Boolean) ?? [];
  const canRunQuery = isEnabled && scopedLocationIds.length > 0 && !!orgId;

  const businessDetailsQueries = useGetBusinessDetailsQueries(
    scopedLocationIds.map((locationId) => ({
      request: { locationId, orgId },
      options: {
        enabled: canRunQuery,
        onError: (error) =>
          sentry.error({
            error,
            team: 'schedule',
            topic: 'scheduling',
            addContext: {
              name: 'GetBusinessDetails error in useSupportedBookingSoftware',
              context: { locationId, orgId, error },
            },
          }),
      },
    }))
  );

  const bookingSoftwareValues = businessDetailsQueries.map((query) => query.data?.businessDetails?.bookingSoftware);

  const hasSupportedBookingSoftware =
    canRunQuery &&
    bookingSoftwareValues.length > 0 &&
    bookingSoftwareValues.every(
      (bookingSoftware) =>
        !!bookingSoftware && SUPPORTED_BOOKING_SOFTWARE.some((supported) => supported === bookingSoftware)
    );

  return {
    hasSupportedBookingSoftware,
    isLoading: businessDetailsQueries.some((query) => query.isLoading),
  };
};
